/*jshint esversion: 6 */

const announcementMap_EXAMPLE = { // EXAMPLE ONLY! DON'T EDIT
  banner: {
    settings: {
      speed: 20, // Pixels per second - consistent speed
      minContentWidth: 1200, // Minimum content width for consistent animation
      animationTime: null // Will be calculated automatically
    },
    blocks: {
      'sale-announcement': {
        text: 'BECOME A REBEL ATHLETE 🚀',
        link: 'https://welcome.levivelabs.com/be-a-rebel',
        linkText: 'GET 3X REBELS FOR FREE',
        highlightColor: '#000',
        textColor: '#111',
        newWindow: false,
        timer: { // is optional
          label: 'REGISTER NOW:',
          endTime: '2025-08-29 12:00:00',
          // ORRRRRRR
          endTime: getNextResetTime(['06:00', '12:00', '18:00', '00:00']),
          highlightColor: '#000'
        }
      }
    }
  }
};

const announcementMap = {
  banner: {
    settings: {
      speed: 20, // Pixels per second - consistent speed
      minContentWidth: 1200, // Minimum content width for consistent animation
      animationTime: null // Will be calculated automatically
    },
    blocks: {
      'sale-announcement': {
        text: 'BECOME A REBEL ATHLETE 🚀',
        link: 'https://welcome.levivelabs.com/be-a-rebel',
        linkText: 'GET 3X REBELS FOR FREE',
        highlightColor: '#000',
        textColor: '#111',
        newWindow: false,
        timer: {
          label: 'REGISTER NOW:',
          // endTime: '2025-08-29 12:00:00', // this is the endtime format
          endTime: getNextResetTime(['06:00', '12:00', '18:00', '00:00']),
          highlightColor: '#000'
        }
      },
    }
  }
};

// const announcementMap = {
//   banner: {
//     settings: {
//       speed: 20, // Pixels per second - consistent speed
//       minContentWidth: 1200, // Minimum content width for consistent animation
//       animationTime: null // Will be calculated automatically
//     },
//     blocks: {
//       'sale-announcement': {
//         text: 'BECOME A REBEL ATHLETE 🚀,
//         link: 'https://welcome.levivelabs.com/be-a-rebel',
//         linkText: 'GET 3X REBELS FOR FREE',
//         highlightColor: '#000',
//         textColor: '#111',
//         newWindow: false,
//         timer: {
//           label: 'REGISTER NOW:',
//           // endTime: '2025-08-29 12:00:00', // this is the endtime format
//           endTime: getNextResetTime(['06:00', '12:00', '18:00', '00:00']),
//           highlightColor: '#000'
//         }
//       },
//     }
//   }
// };

const logoScroller = {
  size_in_px: 160, // how big the logo is
  spacing_in_px: 10, // the higher the value the more spacing between the logos
  animation_seconds_per_image: 2.75, // the higher the value the slower the animation
  trusted_by: {
    // SCROLLING LOGOS ON HOMEPAGE https://levivelabs.com/
    imageUrls: [
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/trusted_by.jpg?v=1753159600",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/mandala_club.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/longevity_hub_white.png?v=1756085660",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/rosewood.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/evelab_insight.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/gcls.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/amiku_health.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/lean.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/technogym.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/pbm.jpg?v=1753151946",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/reiwa_health.png?v=1756913433",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/elyx_white.png?v=1756808401",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/fred_perry_64ef3c42-e782-41e6-afd7-bf2ecfbadc3b.jpg?v=1753954484",
    ],
    size_in_px: 160,
    spacing_in_px: 10,
    animation_seconds_per_image: 2.75,
  },
  rebels_SG_inCollaborationWith: {
    // https://levivelabs.com/pages/rebelsofaging
    imageUrls: [
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/1_amiku.jpg?v=1747184488",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/amili_0cb478e6-1a36-4139-b651-befcc9a2b37d.jpg?v=1753785903",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/osler_health.jpg?v=1753785903",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/eternami.jpg?v=1753785903",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/pbm_59415310-23fd-4f60-af92-ef0baa442bc5.jpg?v=1753954484",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/reiwa_health_black.png?v=1756913432",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/2_evelab.jpg?v=1747184489",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/technogym_998202c0-65d4-48ac-83dc-b88d5583cf3d.jpg?v=1753785903",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/elyx_1.png?v=1756807007"
     
    ],
    size_in_px: 160,
    spacing_in_px: 10,
    animation_seconds_per_image: 2.75,
  },
  rebels_MY_inCollaborationWith: {
    // https://levivelabs.com/pages/rebelsofaging
    imageUrls: [
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", // don't edit this; it's spacing
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/longevity_hub_2.png?v=1756085661",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/1_amiku.jpg?v=1747184488",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/bmw_millenium.jpg?v=1753865439",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/fred_perry.jpg?v=1753787056",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/2_evelab.jpg?v=1747184489",
      "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/4_paloma.jpg?v=1748363331",
    ],
    size_in_px: 160,
    spacing_in_px: 10,
    animation_seconds_per_image: 2.75,
  },
};

const imageMap = {
  example: {
    src: "/images/hero-banner.jpg",
    alt: "Hero banner showing beautiful landscape",
    classes: "img-fluid rounded shadow",
    link: "/gallery",
    newWindow: false,
  },
  hashtag_rebels_of_aging_desktop: {
    src: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/She_is_the_Rebel_of_Aging_1_740bec6c-e517-44cb-9a1d-30d1f8900026.png?v=1754381922",
    alt: "",
  },
  hashtag_rebels_of_aging_mobile: {
    src: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/She_is_the_Rebel_of_Aging.png?v=1754381919",
    alt: "",
  },
};

const bigCarouselMap = {
  example_bigCarouselMap: [
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/chapter_1_bg_2.jpg?v=1753352857',
      vignetteOpacity: 10,
      positionY: '50%',
      positionX: '50%',
      h2Text: 'Skin <b>Longevity</b>',
      h2Color: 'black',
      h2Shadow: true, // or false
      description: 'Discover the science behind biohacking your skin for optimal longevity and health.',
      description_color: 'black', // or
      description_width: '80%',
      description_alignmentY: 'bottom', // or 'top'
      description_alignmentX: 'right', // or 'left', 'center'
      buttonText: 'Show gallery',
      button_alignment: 'start', // or 'end'
      link: '#/',
      newWindow: false,
    },
  ],
  homepage_carousel: [
       {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Levive_Model-246_69bad316-a85a-42d8-935f-75c09cd813a8.jpg?v=1756042184',
      positionY: '8%',
      vignetteOpacity: 10,      
      h2Text: 'Cell <b>Renewal</b>',
      h2Color: 'black',
      description: 'Advanced NMN formula that reactivates your youth genes and slows biological aging.',
      buttonText: 'Shop products',
      link: 'https://levivelabs.com/collections/our-products',
    },
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Levive_Model-204_copy2.jpg?v=1756044968',
      vignetteOpacity: 5,      
      h2Text: 'Skin <b>Longevity</b>',
      h2Color: 'black',
      positionX: '32%', 
      description: 'Breakthrough longevity formulas to block the root causes of skin aging.',
      description_color: '#555',
      description_width: '55%',
      description_alignmentY: 'top',
      description_alignmentX: 'left',
      buttonText: 'Shop products',
      link: 'https://levivelabs.com/collections/our-products',
    },
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/the_rebels_of_aging.jpg?v=1753484618',
      vignetteOpacity: 10,      
      h2Text: '<b>The Rebels</b> of Aging',
      h2Color: 'black',
      description: 'Bluezone community with leading scientists, clinicians and wellness experts & immersive longevity experiences.',
      buttonText: 'Learn more',
      link: 'https://levivelabs.com/pages/rebelsofaging',
    },
                
        {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/biohacking_plan.jpg?v=1753484617',
      vignetteOpacity: 15,      
      h2Text: '<b>Your Biohacking</b> Plan',
      h2Color: 'white',
      description: "Decode your DNA and epegenetics aging patterns and unlock your body's longevity potential.",
      buttonText: 'Shop products',
      link: 'https://levivelabs.com/collections/our-products',
    },
  ],
};


// Nested content map for different icon sections
const iconSectionsContent = {
    homepageValueIcons: [
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_book.png?v=1747187009",
            caption: "Backed<br>by Science"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_german_map.png?v=1747187009",
            caption: "Made in<br>Germany"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_faceglow.png?v=1747187009",
            caption: "For Ageless Health<br>and Beauty"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_holimel.png?v=1747187469",
            caption: "Clinically<br>proven ingredients"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_labtube.png?v=1747187010",
            caption: "Tested and certified by<br>independent Labs"
        }
    ],
    theRadianceValueIcons: [
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_book.png?v=1747187009",
            caption: "Backed<br>by Science"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_german_map.png?v=1747187009",
            caption: "Made & certified<br>in Germany"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_holimel.png?v=1747187469",
            caption: "Holimel®<br>SODB Melon"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_faceglow.png?v=1747187009",
            caption: "Clinically proven<br>UV protection shield"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_labtube.png?v=1747187010",
            caption: "Tested by<br>independent Labs"
        }
    ],
     theGlowValues: [
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_book.png?v=1747187009",
           caption: "Backed<br>by Science"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_german_map.png?v=1747187009",
           caption: "Made and certified<br>in Germany"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/n.jpg?v=1753851487",
           caption: "Proven<br>Niaciamide+"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_faceglow.png?v=1747187009",
           caption: "Scientific Skincare<br>From the Inside"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_labtube.png?v=1747187010",
           caption: "Tested by<br>independent Labs"
       }
   ],
   theRebelValues: [
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_book.png?v=1747187009",
           caption: "Backed<br>by Science"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_german_map.png?v=1747187009",
           caption: "Made<br>in Germany"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/n.jpg?v=1753851487",
           caption: "Science-backed<br>NMN"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/rebel_logo_bddb2d69-d608-46bc-b008-838622aad71e.png?v=1756042967",
           caption: "Proven to support<br>cell renewal"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_labtube.png?v=1747187010",
           caption: "Tested by<br>independent Labs"
       }
   ],
   defaultProductValues: [
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_book.png?v=1747187009",
           caption: "Backed<br>by Science"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_german_map.png?v=1747187009",
           caption: "Made and certified<br>in Germany"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/n.jpg?v=1753851487",
           caption: "Proven<br>Niaciamide+"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_faceglow.png?v=1747187009",
           caption: "Clinically proven<br>UV protection shield"
       },
       {
           icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_labtube.png?v=1747187010",
           caption: "Tested by<br>independent Labs"
       }
   ],
   skinLongevityLandingValueIcons: [
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_book.png?v=1747187009",
            caption: "Backed<br>by Science"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_german_map.png?v=1747187009",
            caption: "Made in<br>Germany"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_faceglow.png?v=1747187009",
            caption: "For Ageless Health<br>and Beauty"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_holimel.png?v=1747187469",
            caption: "Clinically<br>proven ingredients"
        },
        {
            icon: "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/icon_labtube.png?v=1747187010",
            caption: "Tested and certified by<br>independent Labs"
        }
    ],
};

const splitCardCarouselMap = {
  skin_longevity_carousel: [
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Cellular_scenescence.jpg?v=1754011504',
      positionY: '50%',
      positionX: '50%',
      titleText: '<b>Cellular</b> Senescence',
      description: "As cells age, they enter a state of permanent growth arrest called senescence. <b>Senescent cells accumulate over time</b>, releasing inflammatory factors that accelerate tissue aging and reduce skin elasticity.",
      vignetteOpacity: 5,
    },
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Mitochondrial_dysfunction.jpg?v=1754011531',
      positionY: '30%',
      positionX: 'right',
      titleText: '<b>Mitochondrial</b> Dysfunction',
      description: "<b>Mitochondria</b>, the powerhouses of cells, <b>become less efficient with age</b>. This leads to decreased energy production and increased oxidative stress, directly affecting skin cell regeneration and repair.",
      vignetteOpacity: 13,
    },
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Matrix_breakdown.jpg?v=1754011502',
      positionY: '50%',
      positionX: '50%',
      titleText: '<b>Matrix</b> Breakdown',
      description: "The structural proteins that give skin its strength and elasticity—<b>collagen and elastin—break down faster than they can be replaced</b>, leading to wrinkles and sagging. ",
      vignetteOpacity: 5,
    },
    {
      backgroundImage: 'https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Compromised_barrier.jpg?v=1754011503',
      positionY: '50%',
      positionX: '50%',
      titleText: '<b>Compromised</b> Barrier',
      description: "The skin's protective barrier becomes less effective over time, leading to <b>increased water loss</b>, reduced <b>protection against environmental stressors</b>, and <b>impaired immune responses</b>.",
      vignetteOpacity: 5,
    },
  ]
};

// Data structure with variables identified from the HTML
// Defaults: onclick=null, title=null, subtitle=null, buttonVisible=false
// Only backgroundImage is required
const carouselCustomization = {
  example: [
    {
      onclick: "lity('#chapter_3_female')",
      backgroundImage:
        "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/Rebels_of_Aging_Chapter_3_Female.jpg?v=1753284933",
    },
  ],
};

// JavaScript object mapping IDs to HTML content
const contentMap = {

};


const backgroundMap = {
  example: {
    src: '/images/hero-bg.jpg',
    positionX: '40%',
    positionY: '60%',
    vignetteOpacity: 80, // 80% darken
    link: '/gallery',
    newWindow: false,
  }
};